/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Status_Resolved_LimitedInputs */

const en_us2_bodymap_status_resolved_limited = /** @type {(inputs: Bodymap_Status_Resolved_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recovered, with a limit`)
};

const pt_br2_bodymap_status_resolved_limited = /** @type {(inputs: Bodymap_Status_Resolved_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuperado, com limitação`)
};

const es_419_bodymap_status_resolved_limited = /** @type {(inputs: Bodymap_Status_Resolved_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuperado, con limitación`)
};

const pt_pt2_bodymap_status_resolved_limited = /** @type {(inputs: Bodymap_Status_Resolved_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuperado, com limitação`)
};

const fr_fr2_bodymap_status_resolved_limited = /** @type {(inputs: Bodymap_Status_Resolved_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guérison avec une limitation`)
};

const de_de2_bodymap_status_resolved_limited = /** @type {(inputs: Bodymap_Status_Resolved_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erholt, mit Einschränkung`)
};

const it_it2_bodymap_status_resolved_limited = /** @type {(inputs: Bodymap_Status_Resolved_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuperato, con una limitazione`)
};

/**
* | output |
* | --- |
* | "Recovered, with a limit" |
*
* @param {Bodymap_Status_Resolved_LimitedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_status_resolved_limited = /** @type {((inputs?: Bodymap_Status_Resolved_LimitedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Status_Resolved_LimitedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_status_resolved_limited(inputs)
	if (locale === "es-419") return es_419_bodymap_status_resolved_limited(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_status_resolved_limited(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_status_resolved_limited(inputs)
	if (locale === "de-DE") return de_de2_bodymap_status_resolved_limited(inputs)
	if (locale === "it-IT") return it_it2_bodymap_status_resolved_limited(inputs)
	return en_us2_bodymap_status_resolved_limited(inputs)
});
export { bodymap_status_resolved_limited as "bodymap.status.resolved_limited" }